import { showToast } from '../../collections/CollectionUI.js';

export function showCreateModal() {
    this.createModal?.classList.remove('hidden');
    this.createModal?.classList.add('flex');
    document.body.style.overflow = 'hidden';

    const nameInput = document.getElementById('collection-name');
    setTimeout(() => nameInput?.focus(), 100);
}

export function hideCreateModal() {
    this.createModal?.classList.add('hidden');
    this.createModal?.classList.remove('flex');
    document.body.style.overflow = '';

    this.createForm?.reset();
    this.setCreateButtonLoading(false);
}

export async function handleCreateSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.createForm);
    const data = {
        name: formData.get('name')?.trim(),
        description: formData.get('description')?.trim() || '',
        tags: formData.get('tags')?.split(',').map((tag) => tag.trim()).filter(Boolean) || [],
        is_public: formData.get('is_public') === '1'
    };

    if (!data.name) {
        showToast('error', 'Vui lòng nhập tên collection');
        return;
    }

    this.setCreateButtonLoading(true);

    try {
        const response = await this.api.createCollection(data);

        if (response && response.id) {
            showToast('success', 'Tạo collection thành công!');
            this.hideCreateModal();
            this.loadCollections();
            this.loadTags();
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.error('Error creating collection:', error);
        showToast('error', error.message || 'Không thể tạo collection');
    } finally {
        this.setCreateButtonLoading(false);
    }
}

export function setCreateButtonLoading(loading) {
    const button = document.getElementById('submit-create-collection');
    const textElement = button?.querySelector('.create-btn-text');
    const loadingElement = button?.querySelector('.create-btn-loading');

    if (button) {
        button.disabled = loading;
    }

    if (loading) {
        textElement?.classList.add('hidden');
        loadingElement?.classList.remove('hidden');
    } else {
        textElement?.classList.remove('hidden');
        loadingElement?.classList.add('hidden');
    }
}
